import { render, staticRenderFns } from "./LogoutButton.vue?vue&type=template&id=a6a1db9e&scoped=true&"
import script from "./LogoutButton.ts?vue&type=script&lang=ts&"
export * from "./LogoutButton.ts?vue&type=script&lang=ts&"
import style0 from "./LogoutButton.css?vue&type=style&index=0&id=a6a1db9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a1db9e",
  null
  
)

export default component.exports